import { api, ParametersObservedMapLayerMetadata } from "@/lib/api";
import { Dimension } from "@/lib/dimensions";
import {
  getTimeDimensionFromTemporalExtent,
  getVerticalDimensionFromExtent,
} from "@/lib/dimensions/helpers";

export type ObservedLayerDataLoaderData = {
  meta: ParametersObservedMapLayerMetadata;
  dimensions: Dimension[];
};

export class ObservedLayerDataLoader {
  private mapLayerId;

  constructor(mapLayerId: string) {
    this.mapLayerId = mapLayerId;
  }

  async loadLayerData(): Promise<ObservedLayerDataLoaderData> {
    const layerMetaResponse = await api.parameters.getObservedMapLayerMetadata(
      this.mapLayerId,
    );

    const timeDimensions = getTimeDimensionFromTemporalExtent(
      layerMetaResponse.data.temporal_extent,
    );
    const verticalDimension = getVerticalDimensionFromExtent(
      layerMetaResponse.data.vertical_extent,
    );

    return {
      meta: layerMetaResponse.data,
      dimensions: [...timeDimensions, ...(verticalDimension ? [verticalDimension] : [])],
    };
  }
}
